import React from "react";
import "./AreasOfPractice.css";

const AreasOfPractice = () => {
  return (
    <div className="areas-of-practice-page">

      {/* Top Banner */}
      <div className="about_top-1">
        <div className="overlay"></div>

        <div className="glassy-banner-1">
          <h1 className="about-heading-1">Areas Of Practice</h1>
        </div>
      </div>

      {/* Practice Areas */}
      <div className="container">
       <section className="practice-areas">

{[
  // 🔹 Core Laws (Most Important)
  { title: "Constitutional Law", desc: "Fundamental rights cases, public interest litigation, and constitutional matters." },
  { title: "Civil Law", desc: "Comprehensive civil litigation services including property disputes, contract matters, and civil rights cases." },
  { title: "Criminal Law", desc: "Expert criminal defense representation for all types of criminal cases from minor offenses to serious felonies." },
  { title: "Family Law", desc: "Handling matters such as divorce, child custody, maintenance, adoption, and domestic relations." },
  { title: "Property Law", desc: "Real estate transactions, property disputes, title verification, and documentation services." },

  // 🔹 Business / Financial Laws
{ 
  title: "Corporate Law", 
  desc: "Business law services including company formation, compliance, mergers & acquisitions, corporate governance, and matters dealing with NCLT." 
},
  { title: "Banking & Finance Law", desc: "Loan recovery, banking disputes, financial compliance, and debt restructuring." },
  { title: "Tax Law", desc: "GST, income tax, tax planning, and dispute resolution services." },
  { title: "Competition Law", desc: "Advisory and litigation in matters related to anti-competitive practices, mergers, and compliance with competition regulations." },

  // 🔹 Employment & Public Laws
  { title: "Labour & Employment Law", desc: "Workplace disputes, employee rights, labor compliance, and employment-related legal matters." },
  { title: "Consumer Law", desc: "Consumer disputes, deficiency of service, and protection of consumer rights." },
  { title: "Environmental Law", desc: "Legal services related to environmental protection, pollution control, and regulatory compliance." },
  { title: "Insurance Law", desc: "Handling insurance claims, disputes, policy interpretation, and settlement matters." },

  // 🔹 Modern / Specialized Laws
  { title: "Cyber Law", desc: "Handling cybercrime, online fraud, data protection, and IT Act compliance." },
  { title: "Intellectual Property Law", desc: "Global protection of trademarks, copyrights, patents, and intellectual property rights." },
  { title: "Media & Entertainment Law", desc: "Legal services for film, television, digital media, content rights, and entertainment industry agreements." },
  { title: "Real Estate Law", desc: "Property transactions, RERA matters, land disputes, and documentation." },

  // 🌍 International Laws
  { title: "International Law", desc: "Legal matters involving cross-border disputes, treaties, and international regulations." },
  { title: "International Business Law", desc: "Legal support for global trade, cross-border transactions, and compliance." },
  { title: "International Trade Law", desc: "Legal support for import-export regulations, trade agreements, and cross-border commerce." },
  { title: "Immigration Law", desc: "Visa processing, work permits, residency, and immigration legal assistance." },
  { title: "Maritime Law", desc: "Legal matters related to shipping, marine trade, and international waters." },
  { title: "Arbitration & Mediation", desc: "Alternative dispute resolution through arbitration, mediation, and conciliation." },
  { title: "Forensic & Fraud Investigation", desc: "Investigation of cross-border financial fraud, white-collar crimes, and forensic legal analysis." }
].map((item, index) => (
  <div className="practice-area" key={index}>
    <h2>{item.title}</h2>
    <p>{item.desc}</p>
  </div>
))}

</section>
      </div>
    </div>
  );
};

export default AreasOfPractice;